import React from "react";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";

function NotFound ({ t }) {
    return <>{t("Not found")}</>
}

export default React.memo(withTranslation()(withRouter(NotFound)));